import React from 'react';
import styled from 'styled-components';
import CartItem from '../../../domain/entities/Cart/CartItem';
import { CartPrice } from './CommonStyles';
import { IGetPriceOptions } from '../../../controllers/OrderSummaryViewController/OrderSummaryViewController';

interface ICartItemPrices {
  item: CartItem;
  getPrice(price: number, options?: IGetPriceOptions): string;
  showFreeLabelAsPrice: boolean;
  freeLabel: string;
  complimentaryGift: string;
}

const CartItemPricesContainer = styled.div`
  font-size: 14px;
  font-weight: bold;
  letter-spacing: 0.47px;
  display: flex;
  justify-content: space-between;
  align-items: baseline;
`;

const CartItemTotalPrice = styled(CartItemPricesContainer)`
  margin-top: 8px;
  white-space: nowrap;
`;

const CartItemUnitPrice = styled(CartPrice)`
  display: flex
`;

export const InitialPrice = styled.span`
  text-decoration: line-through;
`;

export const UnitPriceWrapper = styled.span`
  display: flex;
  flex-wrap: wrap-reverse;
  margin-right: 10px;
`;

export const UnitPrice = styled.span``;

export const DiscountedUnitPrice = styled.span``;

const CartItemPrices = ({
  item,
  getPrice,
  freeLabel,
  showFreeLabelAsPrice,
  complimentaryGift,
}: ICartItemPrices): JSX.Element => {
  const priceOptions: IGetPriceOptions = {
    freeLabel,
    showFreeLabelAsPrice,
  };

  return (
    <CartItemPricesContainer>
      <CartItemUnitPrice className="acac-cart-item-price">
        {item.isComplimentaryGift
          ? (
            <UnitPrice>
              {complimentaryGift}
            </UnitPrice>
          )
          : item.isDiscounted
            ? (
              <UnitPriceWrapper>
                <InitialPrice className="acac-cart-item-initial-price">
                  {getPrice(item.itemUnitPrice)}
                </InitialPrice>
              &nbsp;
                <DiscountedUnitPrice className="acac-cart-item-discounted-price">
                  {getPrice(item.processedDiscountedPrice, priceOptions)}
                </DiscountedUnitPrice>
              </UnitPriceWrapper>
            )
            : (
              <UnitPrice>
                {getPrice(item.itemUnitPrice, priceOptions)}
              </UnitPrice>
            )}
        </CartItemUnitPrice>
      <CartItemTotalPrice className="acac-cart-item-total-price">
        {// TODO remove this ACCHFRO-10602
      // this was done due to code freeze to fix a critical bug for release
      item.isAutoReplenish
        ? getPrice(item.processedDiscountedPrice * item.quantity, priceOptions)
        : getPrice(item.itemTotalPrice, priceOptions)
      }
      </CartItemTotalPrice>
    </CartItemPricesContainer>
  );
};

export default CartItemPrices;
